import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
} from '@angular/core';
import { CentsToDollarsPipe } from '@marmon/frontend/common';
import {
	CellColorCode,
	ColorCodeCellBase,
} from './color-code-cell-base.component';
import { PercentileCalculation } from '@marmon/shared/types/analysis';

@Component({
	standalone: true,
	providers: [CentsToDollarsPipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'mar-average-transaction-cell',
	templateUrl: 'color-code-cell.component.html',
	host: { class: 'flex gap-2 items-center' },
})
export class AverageTransactionCellComponent extends ColorCodeCellBase<number> {
	readonly toDollars = inject(CentsToDollarsPipe);
	readonly percentiles = input.required<PercentileCalculation | null>();

	override readonly formattedValue = computed(() => {
		let value = this.value();
		if (value === undefined) value = 0;
		return this.toDollars.transform(value);
	});

	override getColorCode(value: number): CellColorCode {
		const percentiles = this.percentiles();
		if (!percentiles) return 'gray';

		if (value >= percentiles[80]) return 'green';
		if (value >= percentiles[40]) return 'yellow';
		return 'red';
	}
}
